var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{attrs:{"color":"pink sticky-toolbar"}},[_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v("ＣｏａｃｈｉｎｇＳｐａｃｅ - "+_vm._s(_vm.showText)+" ")]),_c('v-spacer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }